export default "/images/developer-user-logo.svg?3c9933b193086554458415e234d02369";